export const CHAT_BLINK_PERIOD_MS = 850;
export const CHAT_BLINK_CYCLES = 3;
export const CHAT_BLINK_DURATION_MS = CHAT_BLINK_PERIOD_MS * CHAT_BLINK_CYCLES;

export function createChatBlinkController() {
  const timeouts = new Map();

  return {
    schedule(chatId, onExpire) {
      const id = String(chatId);
      if (timeouts.has(id)) {
        clearTimeout(timeouts.get(id));
      }
      timeouts.set(
        id,
        setTimeout(() => {
          timeouts.delete(id);
          onExpire(id);
        }, CHAT_BLINK_DURATION_MS),
      );
      return id;
    },
    clear(chatId) {
      const id = String(chatId);
      if (timeouts.has(id)) {
        clearTimeout(timeouts.get(id));
        timeouts.delete(id);
      }
      return id;
    },
    dispose() {
      timeouts.forEach((timeoutId) => clearTimeout(timeoutId));
      timeouts.clear();
    },
  };
}
